module.exports = __webpack_public_path__ + "assets/img/1751589512664_.pic_hd.52e83383.jpg";